import React from "react";
import { useRouter } from "next/router";
import { PACKAGE_COLORS } from "../../data/diagnosticQuestions";
import styles from "./PackageRecommendation.module.scss";

const PACKAGE_NAMES = {
    kveikja: "Kveikja",
    vaxa: "Vaxa",
    efla: "Efla",
    dafna: "Dafna",
    none: null,
};

const PACKAGE_FEATURES_IS = {
    kveikja: [
        "120+ aðgerðir",
        "Kolefnisreiknir",
        "Markmið og aðgerðaráætlun",
        "Fullt mælaborð",
        "Laufaskólinn / Fræðsla",
    ],
    vaxa: [
        "Allt í Kveikja",
        "Birgjamat",
        "Fjármálayfirlit",
        "Skýrslur og útflutningur",
        "Starfsmannakannanir / ánægja",
        "Samanburður (benchmark)",
    ],
    efla: [
        "Allt í Vaxa",
        "Kolka raungögn (innifalin)",
        "Eigna-app / fasteignastjóri",
        "Ítarlegur kolefnisútreikningur",
        "HR mælaborð",
        "Sérstakur tengiliður",
    ],
    dafna: [
        "Allt í Efla",
        "Gæðastjórnunarkerfi",
        "Eignastjórnun (tæki og floti)",
        "Kolefnisbókhald (Scope 1/2/3)",
        "Stofnanastjórnun",
        "Heimsmarkmiðin (SDG)",
    ],
    none: [],
};

const PACKAGE_FEATURES_EN = {
    kveikja: [
        "120+ actions",
        "Carbon calculator",
        "Goals & action plan",
        "Full dashboard",
        "Laufaskólinn / Education",
    ],
    vaxa: [
        "Everything in Kveikja",
        "Supplier assessment",
        "Financial overview",
        "Reports & export",
        "Employee surveys / satisfaction",
        "Benchmark comparison",
    ],
    efla: [
        "Everything in Vaxa",
        "Kolka live data (included)",
        "Property manager app",
        "Detailed carbon calculation",
        "HR dashboard",
        "Dedicated contact",
    ],
    dafna: [
        "Everything in Efla",
        "Quality management system",
        "Asset management (fleet)",
        "Carbon accounting (Scope 1/2/3)",
        "Multi-entity management",
        "UN SDGs",
    ],
    none: [],
};

const PACKAGE_PRICES = {
    kveikja: "19.900",
    vaxa: "34.900",
    efla: "74.900",
    dafna: null,
    none: null,
};

const PACKAGE_PRICE_PREFIX = {
    dafna: { is: "frá ", en: "from " },
};

const DAFNA_PRICE = "149.900";

export default function PackageRecommendation({ recommendation, packageText }) {
    const { locale } = useRouter();
    const isEn = locale === "en";
    const color = PACKAGE_COLORS[recommendation] || PACKAGE_COLORS.none;
    const pkgName = PACKAGE_NAMES[recommendation];
    const title = isEn ? packageText.title_en : packageText.title_is;
    const why = isEn ? packageText.why_en : packageText.why_is;
    const badgeLabel = isEn ? "Recommended" : "Ráðlagður pakki";
    const features = isEn
        ? PACKAGE_FEATURES_EN[recommendation] || []
        : PACKAGE_FEATURES_IS[recommendation] || [];

    const price = PACKAGE_PRICES[recommendation];
    const prefix = PACKAGE_PRICE_PREFIX[recommendation];
    const displayPrice = recommendation === "dafna" ? DAFNA_PRICE : price;
    const pricePrefix = prefix ? (isEn ? prefix.en : prefix.is) : "";

    return (
        <div className={styles.container}>
            {pkgName && (
                <div
                    className={styles.badge}
                    style={{
                        borderColor: color,
                        backgroundColor: `${color}10`,
                    }}
                >
                    <span className={styles.badgeLabel}>{badgeLabel}</span>
                    <span className={styles.badgeName} style={{ color }}>
                        {pkgName}
                    </span>
                </div>
            )}

            <h3 className={styles.title}>{title}</h3>
            <p className={styles.why}>{why}</p>

            {features.length > 0 && (
                <ul className={styles.features}>
                    {features.map((f, i) => (
                        <li key={i} className={styles.feature}>
                            <span
                                className={styles.checkmark}
                                style={{ color }}
                            >
                                ✓
                            </span>
                            {f}
                        </li>
                    ))}
                </ul>
            )}

            {displayPrice && (
                <div className={styles.priceRow}>
                    <span className={styles.price} style={{ color }}>
                        {pricePrefix}
                        {displayPrice} kr.
                    </span>
                    <span className={styles.priceUnit}>
                        {isEn ? "/month" : "/mán."}
                    </span>
                </div>
            )}
        </div>
    );
}
